import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import FormContainer from '../common/FormContainer';
import { useRedirectUrl } from '../../lib/hooks/useRedirect';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const ChangePasswordSuccess = () => {
  const { t } = useTranslation();
  const redirectUrl = useRedirectUrl();

  useEffect(() => {
    setTimeout(() => window.location.replace(redirectUrl), 1000);
  }, []);

  return (
    <FormContainer>
      <Paper square sx={{ p: 3, width: 425 }}>
        <Typography variant="h5" gutterBottom>
          {t('auth.changePassword.success.message')}
        </Typography>
      </Paper>
    </FormContainer>
  );
};
